import { useEffect, useState, useRef, useContext } from 'react'
import "../styles/gradientButton.css"
import { useParams, useNavigate } from 'react-router'
import { buildListPath, NUMERIC_RE, formatPhone } from '../lib/urls';
import initialDataContext from '../contexts/initialDataContext';
import { breadcrumbSchema, realEstateListingSchema, categoryName } from '../lib/jsonLd';
import { detailMetaDescription } from '../lib/metaDescriptions';
import { ruDetailPath, ruListPath, ruUrl, RU_BASE_MAP, listPathLang, ruRealEstateListingSchema, ruSotok, ruRooms, ruPlural, ruPrice, CITY_RU , ruValue} from '../lib/ru';
import GatedMap from '../components/GatedMap';
import { useTr } from '../lib/i18n';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import Lightbox from 'yet-another-react-lightbox';
import { Zoom } from 'yet-another-react-lightbox/plugins';
import { RxDimensions } from "react-icons/rx";
import Editor from '../editors/Editor'
import api from '../api';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import InterestModal from '../components/InterestModal';

import 'yet-another-react-lightbox/styles.css';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import '../styles/gallery.css'
import 'quill/dist/quill.snow.css';
import AlteleCard from '../components/AlteleCard';


const AlteleDetail = () => {
    // Data pre-fetched by the Express server during SSR.
    const ssrData = useContext(initialDataContext);
    const ssr = (ssrData && ssrData.type === 'detail' && ssrData.base === 'altele') ? ssrData : null;
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [listing, setListing] = useState(() => ssr?.detail ?? null);
    const [likeListing, setLikeListings] = useState(() => ssr?.similar ?? []);
    const [index, setIndex] = useState(0);
    const [open, setOpen] = useState(false);
    const quillRef = useRef();
    const { param } = useParams();
    const idOrSlug = param;
    const navigate = useNavigate();
    const tr = useTr();
    const lang = tr('ro', 'ru');
    const [showInterest, setShowInterest] = useState(false);

    useEffect(() => {
        if (ssr) return;
        const fetchListing = async () => {
            try {
                const res = await api.get(`api/v1/altele/${idOrSlug}/`);
                setListing(res.data);
                if (NUMERIC_RE.test(idOrSlug) && res.data.listing?.slug) {
                    navigate(`/altele/${res.data.listing.location?.slug ?? res.data.listing.location?.id}/${res.data.listing.slug}`, { replace: true });
                }
            } catch (error) {
                navigate(lang === 'ru' ? '/ru/404' : '/404');
            }
        };

        const fetchLikeListings = async () => {

        }

        fetchListing();
    }, [idOrSlug]);

    useEffect(() => {
        if (ssr) return;

        const fetchLikeListings = async () => {
            try {
                const res = await api.get(`api/v1/altele/?sale_type=${listing?.listing?.sale_type?.id}`);
                setLikeListings(res.data.results);
            } catch (error) {
                navigate(lang === 'ru' ? '/ru/404' : '/404');
            }
        }

        if (listing) {
            fetchLikeListings();
        }

    }, [listing])

    const seoName = lang === 'ru' ? (listing?.listing?.ru_seo_title || listing?.listing?.seo_title || listing?.listing?.street) : (listing?.listing?.seo_title || listing?.listing?.street);

    const roDetailUrl = `https://lvgimob.md/altele/${listing?.listing?.location?.slug ?? listing?.listing?.location?.id}/${listing?.listing?.slug}`;

    const ruDetailUrl = (['ungheni', 'chisinau', 'balti'].includes(listing?.listing?.location?.slug) && listing?.listing?.ru_slug) ? ruUrl(ruDetailPath('prochee', listing.listing.location.slug, listing.listing.ru_slug)) : null;

    const breadcrumbDetail = listing ? breadcrumbSchema([
        { name: tr('Acasă', 'Главная'), item: lang === 'ru' ? 'https://lvgimob.md/ru/' : 'https://lvgimob.md/' },
        { name: lang === 'ru' ? 'Прочее' : categoryName('altele'), item: lang === 'ru' ? `https://lvgimob.md${ruListPath('prochee', listing.listing?.location?.slug, listing.listing?.sale_type?.id)}` : 'https://lvgimob.md/altele' },
        ...(listing.listing?.location?.slug ? [{ name: `Proprietăți în ${listing.listing.location.location}`, item: `https://lvgimob.md/altele/${listing.listing.location.slug}` }] : []),
        { name: seoName || '' },
    ]) : null;
    const realEstateJson = listing ? lang === 'ru' ? ruRealEstateListingSchema('prochee', listing.listing?.location?.slug, listing) : realEstateListingSchema('altele', listing, listing.listing?.sale_type?.id) : null;

    return (
        <>
            {listing && (
                <Helmet>
                    <title>{seoName || 'LVG Imob'}</title>
                    <meta name="description" content={lang === 'ru' ? (listing?.listing?.ru_meta_description || detailMetaDescription('altele', listing)) : detailMetaDescription('altele', listing)} />
                    <link rel="canonical" href={lang === 'ru' ? (ruDetailUrl || roDetailUrl) : roDetailUrl} />
                <link rel="alternate" hreflang="ro" href={roDetailUrl} />
                {ruDetailUrl && <link rel="alternate" hreflang="ru" href={ruDetailUrl} />}
                <link rel="alternate" hreflang="x-default" href={roDetailUrl} />

                    <meta property="og:title" content={seoName || 'LVG Imob'} />
                    <meta property="og:description" content={lang === 'ru' ? (listing?.listing?.ru_meta_description || detailMetaDescription('altele', listing)) : detailMetaDescription('altele', listing)} />
                    <meta property="og:image" content={listing?.listing?.images?.[0]} />
                    <meta property="og:url" content={lang === 'ru' ? (ruDetailUrl || roDetailUrl) : roDetailUrl} />
                    <meta property="og:type" content="article" />
                <script type="application/ld+json">{JSON.stringify(breadcrumbDetail)}</script>
                <script type="application/ld+json">{JSON.stringify(realEstateJson)}</script>
                </Helmet>
            )}


            <section className="py-[60px] sm:py-[80px] px-[12px] sm:container flex flex-col sm:gap-[35px] gap-[25px] sm:mx-auto" style={{ minHeight: "calc(100vh - 88px - 561px)" }}>
                <div className=" xl:grid xl:grid-cols-12 justify-between gap-[40px]">
                    <div className=" xl:col-span-8 flex flex-col sm:gap-[35px] gap-[25px] w-full">
                        <div className="gallery w-full">
                            <Swiper
                                style={{
                                    '--swiper-navigation-color': '#fff',
                                    '--swiper-pagination-color': '#fff',
                                }}
                                spaceBetween={10}
                                navigation={true}
                                thumbs={{ swiper: thumbsSwiper }}
                                modules={[FreeMode, Navigation, Thumbs]}
                                className="mySwiper2 w-full"
                            >
                                {
                                    listing?.listing?.images.map((img, idx) => (
                                        <SwiperSlide key={idx}>
                                            <img onClick={() => {
                                                setIndex(idx);
                                                setOpen(true);
                                            }} src={img} alt={lang === 'ru' ? (listing?.listing?.ru_seo_title || listing?.listing?.seo_title || listing?.listing?.street) : (listing?.listing?.seo_title || listing?.listing?.street)} className='min-h-[200px] cursor-pointer' fetchPriority="high" decoding="async" />
                                        </SwiperSlide>
                                    ))
                                }
                            </Swiper>
                            <Swiper
                                onSwiper={setThumbsSwiper}
                                spaceBetween={10}
                                slidesPerView={4}
                                freeMode={true}
                                watchSlidesProgress={true}
                                modules={[FreeMode, Navigation, Thumbs]}
                                className="mySwiper"
                            >
                                {
                                    listing?.listing?.images.map((img, idx) => (
                                        <SwiperSlide key={idx}>
                                            <img src={img} alt={lang === 'ru' ? (listing?.listing?.ru_seo_title || listing?.listing?.seo_title || listing?.listing?.street) : (listing?.listing?.seo_title || listing?.listing?.street)} className='min-h-[60px] cursor-pointer' loading="lazy" decoding="async" />
                                        </SwiperSlide>
                                    ))
                                }
                            </Swiper>
                        </div>
                        <div className="flex flex-col gap-[5px]">
                            <div className="grid grid-cols-10 justify-between items-center gap-[5px]">
                                <h1 className="text-[20px] col-span-7 font-poppins font-[500] sm:text-[22px]">
                                    {seoName}
                                </h1>
                                <div className="flex gap-[5px] col-span-3 items-center justify-end font-body sm:font-poppins text-[16px] sm:text-[20px] font-[500]">
                                    <RxDimensions className="text-[#d5ab63] text-xl sm:text-3xl" />
                                    <p>{listing?.surface} m²</p>
                                </div>
                            </div>
                        </div>

                        <span className='w-full h-[1px] bg-gray-300'></span>

                        <div className="flex flex-col gap-[15px]">
                            <p className="text-[20px] col-span-7 font-poppins font-[500] sm:text-[22px]">
                                {tr('Descriere', 'Описание')}
                            </p>
                            {lang === 'ru'
    ? (listing?.listing?.ru_description && (
        <div className="whitespace-pre-line text-[15px] font-body text-gray-700 leading-[1.7]">{listing.listing.ru_description}</div>
    ))
    : (
                                listing?.listing?.description && (
                                    <Editor
                                        key={listing.listing?.id}
                                        ref={quillRef}
                                        readOnly={true}
                                        visible={true}
                                        defaultValue={listing.listing.description}
                                    />
                                )
                            )
}
                        </div>

                        <span className='w-full h-[1px] bg-gray-300'></span>

                        <div className="flex flex-col gap-[25px]">
                            <p className="text-[20px] col-span-7 font-poppins font-[500] sm:text-[22px]">
                                {tr('Caracteristici', 'Характеристики')}
                            </p>
                            <div className="flex sm:gap-[200px] gap-[15px] sm:flex-row flex-col">
                                <ul className='flex flex-col gap-[15px]'>
                                    <li>
                                        <div className="flex flex-col">
                                            <p className='text-[16px] font-body text-gray-700'>{tr('Locația', 'Локация')}</p>
                                            <p className='text-[16px] font-body font-[500]'>{lang === 'ru' ? (CITY_RU[listing?.listing?.location?.slug]?.name || listing?.listing?.location?.location) : (listing?.listing?.sector?.sector ? listing.listing.sector.sector : listing?.listing?.location?.location)} 1</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="flex flex-col">
                                            <p className='text-[16px] font-body text-gray-700'>{tr('Suprafața', 'Площадь')}</p>
                                            <p className='text-[16px] font-body font-[500]'>{listing?.surface} m²</p>
                                        </div>
                                    </li>
                                </ul>

                                
                            </div>
                        </div>
                    </div>

                    <div className="xl:h-full xl:col-span-4 xl:block xl:w-auto xl:relative fixed w-full left-0 bottom-0 z-[50] xl:z-1">
                        <div className="hidden xl:block xl:sticky  top-[110px] ">
                            <div className="flex flex-col gap-[25px] bg-[#ececec] p-[30px] rounded-[5px]">
                                <p className='font-poppins text-[18px] font-[500] tracking-wider'>{tr('Preț', 'Цена')} <span className='text-[#d5ab63]'>& {tr('Contacte', 'Контакты')}</span> </p>
                                <div className="flex flex-col gap-[15px]">

                                    <div className="flex flex-col gap-[15px] border border-gray-300 shadow rounded-[5px] p-[20px]">
                                        <div className="flex gap-[3px] items-center text-[24px] font-[500] font-poppins tracking-wider">
                                            <p>{lang === 'ru' ? ruPrice(listing?.listing?.price) : new Intl.NumberFormat('ro-RO').format(listing?.listing?.price)}</p>
                                            <p>€</p>
                                            <p>{listing?.listing?.availability ? '' : (lang === 'ru' ? '- Недоступно' : '- Indisponibil')}</p>
                                        </div>
                                        <span className='w-full h-[1px] bg-gray-300'></span>
                                        <div className="flex gap-[3px] justify-between items-center text-[18px] font-[500] font-poppins tracking-wider ">
                                            <div className="flex flex-col gap-[5px]">
                                                <p>{listing?.listing?.user?.last_name} {listing?.listing?.user?.first_name}</p>
                                                <a href={`tel:${formatPhone(listing?.listing?.user?.phone)}`} className='text-[18px] text-[#d5ab63] hover:underline'>{formatPhone(listing?.listing?.user?.phone)}</a>
                                            </div>
                                            <a href={`tel:${formatPhone(listing?.listing?.user?.phone)}`} className='btn-main rounded-[5px] text-white text-[16px] px-[20px] py-[7px]'>{tr('Apel', 'Позвонить')}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button
                                onClick={() => setShowInterest(true)}
                                className='btn-main text-white text-[15px] font-body px-[20px] py-[10px] rounded-[5px] cursor-pointer w-full'
                            >
                                {tr('Ești interesat? Trimite cerere', 'Заинтересованы? Оставить заявку')}
                            </button>
                        </div>

                        <div className="flex xl:hidden bg-[#ececec] flex-col gap-[8px] border border-gray-300 rounded-t-[5px] px-[20px] py-[10px]">
                            <div className="flex gap-[3px] items-center text-[22px] font-[500] font-poppins tracking-wider">
                                <p>{lang === 'ru' ? ruPrice(listing?.listing?.price) : new Intl.NumberFormat('ro-RO').format(listing?.listing?.price)}</p>
                                <p>€</p>
                                <p>{listing?.listing?.availability ? '' : (lang === 'ru' ? '- Недоступно' : '- Indisponibil')}</p>
                            </div>
                            <span className='w-full h-[1px] bg-gray-300'></span>
                            <div className="flex gap-[3px] justify-between items-center text-[16px] font-[500] font-poppins tracking-wider ">
                                <div className="flex flex-col gap-[5px]">
                                    <p>{listing?.listing?.user?.last_name} {listing?.listing?.user?.first_name}</p>
                                    <a href={`tel:${formatPhone(listing?.listing?.user?.phone)}`} className='text-[16px] text-[#d5ab63] hover:underline'>{formatPhone(listing?.listing?.user?.phone)}</a>
                                </div>
                                <a href={`tel:${formatPhone(listing?.listing?.user?.phone)}`} className='btn-main rounded-[5px] text-white text-[14px] px-[20px] py-[7px]'>{tr('Apel', 'Позвонить')}</a>
                            </div>
                            <button onClick={() => setShowInterest(true)} className='btn-main text-white text-[14px] font-body px-[20px] py-[8px] rounded-[5px] cursor-pointer'>{tr('Ești interesat? Trimite cerere', 'Заинтересованы? Оставить заявку')}</button>
                        </div>
                    </div>
                </div>

                <span className='w-full h-[1px] bg-gray-300 -mt-[15px]'></span>

                <div className="flex flex-col gap-[10px]">
                    <p className="text-[20px] col-span-7 font-poppins font-[500] sm:text-[22px]">
                        {tr('Locația', 'Локация')}
                    </p>
                    <p className='text-[18px] font-body text-gray-700 sm:text-[20px]'>{lang === 'ru' ? (listing?.listing?.ru_title || listing?.listing?.street) : listing?.listing?.street}</p>
                    <GatedMap
                            src={`https://www.google.com/maps?q=${encodeURIComponent(lang === 'ru' ? (listing?.listing?.ru_title || listing?.listing?.street) : listing?.listing?.street || '')}&output=embed`}
                            minHeight="450px" />
                </div>

                <span className='w-full h-[1px] bg-gray-300 -mt-[15px]'></span>

                <div className="flex flex-col gap-[10px]">
                    <p className="text-[20px] col-span-7 font-poppins font-[500] sm:text-[22px]">
                        {tr('Anunțuri asemănătoare', 'Похожие объявления')}
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-[30px] text-black">
                        {
                            likeListing
                                .filter((item) => item.id !== listing.id)
                                .slice(0, 4)
                                .map((item, idx) => (
                                    <AlteleCard key={idx} listing={item} />
                                ))
                        }
                    </div>
                    <div className="mx-auto mt-[15px]">
                        <Link to={listPathLang(lang, 'altele', { location: listing?.listing?.location?.slug, saleType: listing?.listing?.sale_type?.id })} className='btn-main rounded-[5px] text-white text-[16px] px-[20px] py-[7px]'>{tr('Vezi toate', 'Все объявления')}</Link>
                    </div>
                </div>
            </section>
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                index={index}
                slides={listing?.listing?.images.map((img) => ({ src: img }))}
                plugins={[Zoom]}
            />
            {showInterest && listing && (
                <InterestModal listing={listing} base="altele" onClose={() => setShowInterest(false)} />
            )}
        </>
    )
}

export default AlteleDetail
